import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState } from 'react';
import { c as clsx } from './clsx.m-7e9a4a81.js';
import { CSSTransition } from 'react-transition-group';

var _excluded = ["block", "small", "color", "children", "type", "loading", "disabled", "style", "className", "onMouseEnter"],
    _excluded2 = ["className", "disabled", "children", "display", "onClick"],
    _excluded3 = ["inline", "small", "color", "children", "style", "type", "disabled", "prefix", "afterfix"],
    _excluded4 = ["href", "color", "children", "style", "type", "disabled", "prefix", "suffix", "ctaArrow", "className"],
    _excluded5 = ["href", "color", "children", "style", "type", "disabled", "prefix", "suffix", "ctaArrow", "className"],
    _excluded6 = ["color", "children", "style", "type", "disabled"];

var Arrow = function Arrow() {
  return /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__arrow"
  }, "\u2192");
};

var PrimaryButton = /*#__PURE__*/React__default.forwardRef(function PrimaryButton(_ref, ref) {
  var block = _ref.block,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      color = _ref.color,
      children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      loading = _ref.loading,
      disabled = _ref.disabled;
      _ref.style;
      var className = _ref.className,
      _onMouseEnter = _ref.onMouseEnter,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: clsx(className, 'smb-button smb-button--primary', loading && 'smb-button--loading', small && 'smb-button--primary--small', hovered && 'smb-button--primary--hovered', color && "smb-button--primary--color-".concat(color), block && "smb-button--primary--block"),
    onMouseEnter: function onMouseEnter(e) {
      setHovered(true);
      _onMouseEnter === null || _onMouseEnter === void 0 ? void 0 : _onMouseEnter(e);
    },
    type: type,
    disabled: disabled || loading
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children), /*#__PURE__*/React__default.createElement(Arrow, null)), /*#__PURE__*/React__default.createElement(CSSTransition, {
    timeout: 300,
    classNames: "smb-button--primary__loading-stripe",
    "in": loading,
    unmountOnExit: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-button--primary__loading-stripe"
  })));
});
var AlphaButton = /*#__PURE__*/React__default.forwardRef(function PrimaryButton(_ref2, ref) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      children = _ref2.children,
      display = _ref2.display,
      onClick = _ref2.onClick,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    role: "button",
    tabIndex: disabled ? undefined : 0,
    className: clsx(className, 'smb-button smb-button--alpha', disabled && 'smb-button--disabled', display === 'inline-block' && 'smb-button--alpha--inline-block'),
    onClick: disabled ? undefined : onClick
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children));
});
/**
 * @deprecated
 */

/**
 * @deprecated
 */
var TertiaryButton = /*#__PURE__*/React__default.forwardRef(function TertiaryButton(_ref3, ref) {
  var inline = _ref3.inline;
      _ref3.small;
      var color = _ref3.color,
      children = _ref3.children;
      _ref3.style;
      var _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'button' : _ref3$type,
      disabled = _ref3.disabled,
      _ref3$prefix = _ref3.prefix,
      prefix = _ref3$prefix === void 0 ? null : _ref3$prefix,
      _ref3$afterfix = _ref3.afterfix,
      afterfix = _ref3$afterfix === void 0 ? /*#__PURE__*/React__default.createElement(Arrow, null) : _ref3$afterfix,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: clsx('smb-button smb-button--tertiary', inline && 'smb-button--tertiary--inline', "smb-typoel smb-color-".concat(color !== null && color !== void 0 ? color : 'dark-green')),
    type: type,
    disabled: disabled
  }, rest, {
    ref: ref
  }), prefix, /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children), afterfix);
});
var TextButton = /*#__PURE__*/React__default.forwardRef(function TextButton(_ref4, ref) {
  _ref4.href;
      var color = _ref4.color,
      children = _ref4.children;
      _ref4.style;
      var _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'button' : _ref4$type,
      disabled = _ref4.disabled,
      _ref4$prefix = _ref4.prefix,
      prefix = _ref4$prefix === void 0 ? null : _ref4$prefix,
      _ref4$suffix = _ref4.suffix,
      suffix = _ref4$suffix === void 0 ? null : _ref4$suffix,
      ctaArrow = _ref4.ctaArrow,
      _className = _ref4.className,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  var className = clsx('smb-button smb-button--text', "smb-typoel smb-color-".concat(color !== null && color !== void 0 ? color : 'dark-green'), _className);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: className,
    type: type,
    disabled: disabled
  }, rest, {
    ref: ref
  }), prefix, /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children), ctaArrow ? /*#__PURE__*/React__default.createElement(Arrow, null) : suffix);
});
var TextLinkButton = /*#__PURE__*/React__default.forwardRef(function TextLinkButton(_ref5, ref) {
  var href = _ref5.href,
      color = _ref5.color,
      children = _ref5.children;
      _ref5.style;
      _ref5.type;
      _ref5.disabled;
      var _ref5$prefix = _ref5.prefix,
      prefix = _ref5$prefix === void 0 ? null : _ref5$prefix,
      _ref5$suffix = _ref5.suffix,
      suffix = _ref5$suffix === void 0 ? null : _ref5$suffix,
      ctaArrow = _ref5.ctaArrow,
      _className = _ref5.className,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  var className = clsx('smb-button smb-button--text', "smb-typoel smb-color-".concat(color !== null && color !== void 0 ? color : 'dark-green'), _className);
  return /*#__PURE__*/React__default.createElement("a", _extends({
    className: className,
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, rest, {
    ref: ref
  }), prefix, /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children), ctaArrow ? /*#__PURE__*/React__default.createElement(Arrow, null) : suffix);
});
var SecondaryButton = /*#__PURE__*/React__default.forwardRef(function SecondaryButton(_ref6, ref) {
  var color = _ref6.color,
      children = _ref6.children;
      _ref6.style;
      var _ref6$type = _ref6.type,
      type = _ref6$type === void 0 ? 'button' : _ref6$type,
      disabled = _ref6.disabled,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: clsx('smb-button smb-button--secondary', "smb-typoel smb-color-".concat(color !== null && color !== void 0 ? color : 'dark-green')),
    type: type,
    disabled: disabled
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "smb-button__inner"
  }, children), /*#__PURE__*/React__default.createElement(Arrow, null));
});
var Button = {
  Primary: PrimaryButton,

  /**
   * @deprecated
   */
  Tertiary: TertiaryButton,
  Secondary: SecondaryButton,
  Text: TextButton,
  TextLink: TextLinkButton,
  Alpha: AlphaButton,
  Arrow: Arrow
};

export { Button as B };
